var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.456 24.504c6.684 0 12.218-5.546 12.218-12.217C24.674 5.603 19.128.07 12.444.07 5.773.07.24 5.603.24 12.287c0 6.671 5.546 12.217 12.217 12.217zm0-2.036A10.132 10.132 0 012.287 12.287c0-5.654 4.504-10.181 10.157-10.181a10.16 10.16 0 0110.193 10.18 10.135 10.135 0 01-10.18 10.182zm-1.305-6.576c.97 0 1.88-.275 2.647-.767l3.066 3.055c.24.263.503.371.85.371.576 0 .97-.42.97-1.03 0-.276-.131-.527-.323-.719l-3.09-3.102c.54-.802.863-1.76.863-2.79a4.994 4.994 0 00-4.983-4.983c-2.743 0-4.983 2.251-4.983 4.982a4.994 4.994 0 004.983 4.983zm0-1.629c-1.833 0-3.354-1.521-3.354-3.354 0-1.82 1.521-3.341 3.354-3.341a3.359 3.359 0 013.342 3.341c0 1.833-1.51 3.354-3.342 3.354z",
    fill: "currentColor"
  })));
}

export default SvgSearch;